import React from 'react';
import PropTypes from 'prop-types';

import { formatIndexDate, cutDate } from '../../services/utils';

const getIndexValue = (indices, product_id, date) => {
    const cuttedDate = cutDate(date);

    if (product_id in indices && cuttedDate in indices[product_id] && indices[product_id][cuttedDate].index) {
        return indices[product_id][cuttedDate].index;
    }

    return '-';
};

const DateColumn = ({ products, showPopup, day, indices }) => {
    return (
        <div className="indices-table-date-item">
            <div className="indices-table-date">
                <span onClick={showPopup}>{formatIndexDate(day)}</span>
            </div>
            {products
                ? products.map((item, i) => (
                      <div key={`prodId${item.id}`} className="indices-table-index">
                          {getIndexValue(indices, item.id, day)}
                      </div>
                  ))
                : null}
        </div>
    );
};

DateColumn.propTypes = {
    showPopup: PropTypes.func.isRequired,
    day: PropTypes.string.isRequired,
    products: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    indices: PropTypes.shape({}).isRequired,
};

export default DateColumn;



// WEBPACK FOOTER //
// ./source/components/manageIndices/dateColumn.js